/**
 * dia-material-subtitle.js
 *
 * Keeps the material line under the product title in sync with the selected
 * colour, so "14K Yellow Gold with Lab Created Diamond" becomes
 * "14K White Gold with Lab Created Diamond" when the shopper switches metal.
 *
 * Why this exists: the theme re-renders the product section on a variant change
 * and copies a fixed list of elements (Price, Sku, Inventory, ...) from the
 * response into the live DOM. That list is defined inside the minified
 * product-info.js and does not include the title block, so the subtitle would
 * otherwise keep the colour the page was first loaded with. The variantChange
 * payload already carries the parsed response document, so the swap costs no
 * extra request.
 */
(function () {
  'use strict';

  var SUBTITLE_ID_PREFIX = 'MaterialSubtitle-';

  function syncSubtitle(payload) {
    var data = payload && payload.data;
    if (!data || !data.html || !data.sectionId) return;

    var id = SUBTITLE_ID_PREFIX + data.sectionId;
    var incoming = data.html.getElementById(id);
    var current = document.getElementById(id);
    if (!incoming || !current) return;

    if (current.innerHTML !== incoming.innerHTML) {
      current.innerHTML = incoming.innerHTML;
    }
  }

  function init() {
    // The theme exposes a pub/sub bus; bail quietly if it is unavailable.
    if (typeof window.subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) {
      return;
    }

    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (payload) {
      // Never let a DOM hiccup here break the theme's other variantChange
      // subscribers (price, inventory, etc.).
      try {
        syncSubtitle(payload);
      } catch (err) {
        console.warn('dia-material-subtitle: sync skipped', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
